module.exports = __webpack_public_path__ + "static/media/ai-1.7c8d5996.jpg";